/**
 * AG Grid valueFormatter for copy/paste of the Trade-Wide Settings (cog) cell.
 *
 * LQC-1699 — the cog cell must copy NOTHING. The cell binds to `field: "status"`,
 * so without a formatter AG Grid would copy the trade status. Returning an empty
 * string here overrides that and yields a blank clipboard value for this cell.
 */
export function tradeWideSettingsValueFormatter(): string {
  return "";
}
